<template>
  <div class="vkb_nak vkb_nak_spv vkb_nak_index">
    <div class="row">
      <div v-if="!config.index_name" class="large-12 columns">
        <div class="row wrapper-spacing pb-0">
          <div class="medium-12 large-12 columns">
            <h1>Wählen Sie Ihren Index</h1>
            <h3>Indizes</h3>

            <div class="spv-select-group row">
              <div
                v-for="product_variant in product_variants"
                :key="product_variant.id"
                :class="`col-variant columns`"
              >
                <div
                  :class="['spv-select-group__option', {
                    'selected': product_variant_.id === product_variant.id,
                  }]"
                  @click="product_variant_ = product_variant"
                >
                  <h3 class="caption" v-html="product_variant.label" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <spv-general
          v-show="product_variant_.id === 'trend'"
          :index-id="'trend'"
          :show-style="show_style"
        />

        <spv-trend
          v-show="product_variant_.id === 'trend-old'"
          :index-id="'trend-old'"
          :show-style="show_style"
        />

        <spv-general
          v-show="product_variant_.id === 'deka'"
          :index-id="'deka'"
          :show-style="show_style"
        />

        <spv-deka
          v-show="product_variant_.id === 'deka-old'"
          :index-id="'deka-old'"
          :show-style="show_style"
        />

        <spv-general
          v-show="product_variant_.id === 'climate'"
          :index-id="'climate'"
          :show-style="show_style"
        />

        <spv-climate
          v-show="product_variant_.id === 'climate-old'"
          :index-id="'climate-old'"
          :show-style="show_style"
        />

        <spv-general
          v-show="product_variant_.id === 'euro'"
          :index-id="'euro'"
          :show-style="show_style"
        />

        <spv-general
          v-show="product_variant_.id === 'vola'"
          :index-id="'vola'"
          :show-style="show_style"
        />
      </div>

      <div v-else class="large-12 columns">
        <spv-general
          v-if="config.index_name === 'trend'"
          :index-id="`trend`"
          :show-style="show_style"
        />

        <spv-trend
          v-if="config.index_name === 'trend-old'"
          :index-id="'trend-old'"
          :show-style="show_style"
        />

        <spv-general
          v-if="config.index_name === 'deka'"
          :index-id="`deka`"
          :show-style="show_style"
        />

        <spv-deka
          v-if="config.index_name === 'deka-old'"
          :index-id="'deka-old'"
          :show-style="show_style"
        />

        <spv-general
          v-if="config.index_name === 'climate'"
          :index-id="`climate`"
          :show-style="show_style"
        />

        <spv-climate
          v-if="config.index_name === 'climate-old'"
          :index-id="'climate-old'"
          :show-style="show_style"
        />

        <spv-general
          v-if="config.index_name === 'euro' || config.index_name === 'euro_2'"
          :index-id="`euro`"
          :show-style="show_style"
        />

        <spv-general
          v-if="config.index_name === 'vola' || config.index_name === 'vola_2'"
          :index-id="`vola`"
          :show-style="show_style"
        />
      </div>
    </div>
  </div>
</template>

<script>
import spvTrend from './spv_trend';
import spvDeka from './spv_deka';
import spvClimate from './spv_climate';
import spvGeneral from './spv_general';
import logic from './logic';

export default {
  name: 'index_spv',

  components: {
    spvTrend,
    spvDeka,
    spvClimate,
    spvGeneral
  },

  mixins: [ logic ]
};
</script>


// WEBPACK FOOTER //
// src/apps/index/spv.vue